/**
 * This is a reducer for everything related to authorizations
 */
import { AuthActionParams, AuthActionsTypes } from './auth-actions';
import { IUser } from '../../utils/userHandler';
import initialState from '../../initialState';
import StoreModel, { LoadedSingleResource } from '../StoreModel';


export interface AuthState {
    user?: IUser;
    request: LoadedSingleResource,
    token?: string,
}

export default (state = initialState.auth, action?: AuthActionParams): AuthState => {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case AuthActionsTypes.REQUEST_LOGIN:
            return {
                ...state,
                request: StoreModel.fetchingSingle()
            }
        case AuthActionsTypes.RESPONSE_LOGIN:
            return {
                user: action.payload,
                token: (action.payload && action.payload.token),
                request: StoreModel.resultSingle(action.payload),
            };

        case AuthActionsTypes.ERROR_LOGIN:
            return {
                ...state,
                request: StoreModel.errorSingle(action.payload)
            }

        case AuthActionsTypes.LOGOUT:
            return { request: StoreModel.defaultSingle() };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/auth/auth-reducer.ts